const isMobile = function (e) {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (e && e.target.outerWidth <= 1000)) {
    return true
  } else {
    return false
  }
}

export default isMobile
